import React, { useState, useEffect, useMemo, useRef } from 'react'
import { last, remove } from 'lodash-es'
import styled from '@emotion/styled'
import { Cascader, Toast } from '@ow/comps'
import { queryNode } from '@ow/utils'
import { useDitto } from '@ow/ditto-core'

const StyleStandardItem = styled.div`
  .close {
    display: none;
  }
  &:hover {
    .close {
      display: block;
    }
  }
`

const Render = function ({
  opts = {},
  onChange,
  value,
  formControl,
  style = {},
}) {
  const { onFetchRemoteData } = useDitto()
  const { multiple } = opts
  const [standards, setStandards] = useState([])
  const [limit, setLimit] = useState([])
  const defaultValue = (value && value.map((v) => v.join('-'))) || []

  const areaIdRef = useRef()

  const standard = useMemo(
    () => (onFetchRemoteData ? onFetchRemoteData('standard') : null),
    []
  )

  const { watch, getValues } = formControl

  const tree = useMemo(
    () => standard.filterStandards(standards, limit),
    [standards, limit]
  )
  const multipleStandard = useMemo(() => {
    if (multiple && value && value.length && standards.length) {
      return value
        .map((v) => {
          const node = queryNode(standards, last(v))
          if (node) {
            return { ...node, title: node.parentsName.join('-') }
          }
          return null
        })
        .filter((v) => v)
    }
    return null
  }, [value, standards])

  useEffect(() => {
    if (!standard) return () => {}

    const getRuleLimit = (area) => {
      if (!area?.length) return

      const areaId = area[area.length - 1]
      if (areaIdRef.current === areaId) return

      areaIdRef.current = areaId

      standard.fetchAreaBindStandard(area).then((binded) => {
        setLimit(binded)
      })
    }

    getRuleLimit(getValues('area'))

    const subscription = watch((data, { name }) => {
      if (name !== 'area') return
      getRuleLimit(data.area)
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    if (!standard) return
    standard.fetchEffectiveTreeData().then((data) => {
      setStandards(data)
    })
  }, [])

  return (
    <div className="w-full">
      <Cascader
        selectLeaf
        tree={tree}
        inputStyle={{ width: '100%', height: '34px', ...style }}
        fieldNames={{
          key: 'parentsIdStr',
          label: 'title',
          value: 'parentsIdStr',
          children: 'children',
        }}
        treeNodeLabelProp="parentsNameStr"
        value={defaultValue}
        multiple={multiple}
        onChange={(selectedKeys) => {
          if (
            value &&
            ((selectedKeys && selectedKeys.length < value.length) ||
              !selectedKeys)
          ) {
            if (selectedKeys) {
              onChange(
                multiple
                  ? (selectedKeys || []).map((v) => {
                      return v.split('-')
                    })
                  : [selectedKeys.split('-')]
              )
            } else {
              onChange([])
            }
          }
        }}
        onSelect={(val, node) => {
          if (node.children || node.isParentNode) {
            Toast.error({
              title: '只能选择末级指标',
            })
          } else {
            onChange(
              multiple
                ? (value || []).concat([val.split('-')])
                : [val.split('-')]
            )
          }
        }}
      />
      {multipleStandard && (
        <div className="w-full flex flex-col gap-2 mt-2">
          {multipleStandard.map((item) => {
            return (
              <StyleStandardItem
                className="cursor-pointer flex items-center justify-between standard-item"
                key={item.id}
                style={{
                  background: 'var(--ow-color-neutral-100)',
                  borderRadius: '4px',
                  padding: '2px 8px',
                  fontWeight: 400,
                  fontSize: '14px',
                }}
              >
                <span>{item.title}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="close"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  strokeWidth="1"
                  stroke="#666"
                  fill="#666"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  onClick={() => {
                    onChange(
                      remove(value, (v) => {
                        return last(v) !== item.id
                      })
                    )
                  }}
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M18 6l-12 12" />
                  <path d="M6 6l12 12" />
                </svg>
              </StyleStandardItem>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default Render
